import { TAG_REGEX } from "constants/tags";
import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * Checks if string is valid Tag format
 * @param  {String} string
 * @returns {Boolean}
 */
function validTags(string) {
  const variableRegex = /{([\w]+)\|([^}]*?)}/g;
  const emptyString = "";

  return string.replace(variableRegex, emptyString)
    .replace(TAG_REGEX, emptyString)
    .replace(/ /g, emptyString) !== emptyString;
}

/**
 * @class ZendeskLiveAgentMessageRecord
 * @augments BaseMessageRecord
 */
class ZendeskLiveAgentMessageRecord extends BaseMessageRecord({
  type: "zendesk_live_agent",
  fallbackResponseId: null,
  departmentId: null,
  departmentName: null,
  tags: ""
}) {}

/**
 * Validation
 */

/**
 * @param {ZendeskLiveAgentMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
ZendeskLiveAgentMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.departmentId) {
    invalidFields.add("departmentId");
  }

  if (!message.fallbackResponseId) {
    invalidFields.add("fallbackResponseId");
  }

  if (message.tags && validTags(message.tags)) {
    invalidFields.add("tags");
  }

  return Immutable.List(invalidFields);
};

export default ZendeskLiveAgentMessageRecord;
